// src/SplitImageGrid.js
import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";

const SplitImageGrid = () => {
  const grids = [
    { title: "3x1 Grid", dimensions: "3240 x 1080px", rows: 1 },
    { title: "3x2 Grid", dimensions: "3240 x 2160px", rows: 2 },
    { title: "3x3 Grid", dimensions: "3240 x 3240px", rows: 3 },
    { title: "3x4 Grid", dimensions: "3240 x 4320px", rows: 4 },
    { title: "3x5 Grid", dimensions: "3240 x 5400px", rows: 5 },
    { title: "3x6 Grid", dimensions: "3240 x 6480px", rows: 6 },
  ];

  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: 2,
        padding: { xs: "50px", sm: "50px", md: "50px 100px" },
        boxSizing: "border-box",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.1)",
        borderRadius: "16px",
      }}
    >
      <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
        Recommended Dimensions for Split Images
      </Typography>

      <Grid container spacing={4} sx={{ mt: 4 }}>
        {grids.map((grid, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={2} // Adjusting the breakpoint for larger screens
            key={index}
            sx={{ textAlign: "center" }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#9c27b0" }}
            >
              {grid.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
              {grid.dimensions}
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: `repeat(3, 50px)`,
                gap: "2px",
                justifyContent: "center",
              }}
            >
              {Array(grid.rows * 3)
                .fill()
                .map((_, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      width: "50px",
                      height: "50px",
                      border: "2px solid #cc33ff",
                    }}
                  />
                ))}
            </Box>
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="h5"
        fontWeight={700}
        align="center"
        mt={2}
        gutterBottom
      >
        Having trouble with image dimensions ?
      </Typography>
      <Typography variant="h6" fontWeight={500} align="center" gutterBottom>
        Checkout our Image dimension resizer below to get an ideal image
        dimension for your instagram grid.
      </Typography>
    </Container>
  );
};

export default SplitImageGrid;
